// extracted by mini-css-extract-plugin
export var benefitSlider = "component-module--benefitSlider--VDQ6l";
export var headerContainer = "component-module--headerContainer--3Wnr6";
export var header = "component-module--header--21suP";
export var buttonContainer = "component-module--buttonContainer--rWgSr";
export var buttonLeft = "component-module--buttonLeft--2xVlC";
export var buttonRight = "component-module--buttonRight--2PnVk";
export var features = "component-module--features--NPi1i";
export var feature = "component-module--feature--1t5NE";